import IpsAvatar from './IpsAvatar.vue';
import '../../../styles/custom.scss';

export default IpsAvatar;
